<template>
  <div class="container pb-30"><product-detail /></div>
</template>
<style lang="scss" src="./detail.scss">
</style>

<script>
import ProductDetail from '../../components/product-detail/product-detail';
export default {
  name: 'Detail',
  components: {
    'product-detail': ProductDetail
  },
  created() {},
  methods: {}
};
</script>
